module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/jakub-poster-5df1a6065f29c9480665455256a25e68.jpg";